import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { BASE_URI } from '@/shared/config';

export const getReportStudyArchiveURL = (
  reportID: string,
  studyType: StudyType,
  timezone: string,
): string =>
  `${BASE_URI}/api/storage/download/report_study_archive/${encodeURIComponent(reportID)}/${studyType}?timezone=${encodeURIComponent(timezone)}`;
